export const monthDay = (timestamp) => {
  const dateObject = new Date(timestamp);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    weekday: "long",
  };
  const formattedDate = dateObject.toLocaleDateString("en-US", options);

  return formattedDate;
};

//Output:Like "Sunday, 01 Jan 2023"
